'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Component which displays the reservation in a popup, when elements marked
// with class open-winres-reservation are clicked.
//
// The contents of the button need to be transcluded into the popup (separate
// component), so hacks are used and this is not a component but a directive.
//
// The popup is also shown on bank return (both successful and unsuccessful),
// so it can be used to show the payment confirmation.

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

require('./winresReservationPopupContent');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[Popup]');

var WinresReservationPopupController = function () {
    function WinresReservationPopupController($uibModalInstance, content, $rootScope) {
        _classCallCheck(this, WinresReservationPopupController);

        this.$uibModalInstance = $uibModalInstance;
        this.content = content;
        this.$rootScope = $rootScope;
    }

    _createClass(WinresReservationPopupController, [{
        key: 'Close',
        value: function Close() {
            this.$uibModalInstance.close();
            this.$rootScope.$broadcast('close-popup');
        }
    }, {
        key: 'Dismiss',
        value: function Dismiss() {
            this.$uibModalInstance.dismiss();
            this.$rootScope.$broadcast('close-popup');
        }
    }]);

    return WinresReservationPopupController;
}();

WinresReservationPopupController.$inject = ['$uibModalInstance', 'content', '$rootScope'];

_module3.default.controller('winresReservationPopupController', WinresReservationPopupController);

_module3.default.directive('winresReservationPopup', ['$rootScope', '$timeout', '$uibModal', 'winresReservationContextService', function ($rootScope, $timeout, $uibModal, winresReservationContextService) {
    return {
        restrict: 'E', //Element-only usage
        transclude: true, //Accept HTML contents of the element
        link: function link($scope, $element, $attrs, requiredControllers, $transclude) {
            $scope.contextForPopup = requiredControllers && requiredControllers['context'];

            // I'm pretty sure that this is some kind of a misunderstanding of how things are supposed to work,
            // and the way things are done in winres-shopping-cart-modal is a better way, but I'm not touching
            // this any more than I need to.
            var transcludedElement;
            $transclude($scope, function (clone) {
                transcludedElement = clone;
            });

            function openModal() {
                var modal = $uibModal.open({
                    // Popup content only appends the passed content into it.
                    template: '<a href="javascript:void(0)" class="close-button glyphicon glyphicon-remove-sign exitBtn" ng-click="$ctrl.Dismiss()"></a><winres-reservation-popup-content content="$ctrl.content"></winres-reservation-popup-content><button class="exitBtnReturn" ng-i18next ng-click="$ctrl.Dismiss()">common.return_back</button><loading-overlay dynamic-size="true"></loading-overlay>',
                    controller: 'winresReservationPopupController',
                    controllerAs: '$ctrl',
                    bindToController: true,
                    windowClass: 'winres-web-component',
                    size: 'lg',
                    resolve: {
                        content: function content() {
                            return transcludedElement;
                        }
                    }
                });

                $timeout(function () {
                    $rootScope.$broadcast('resizeOverlay');
                });
            }

            // log('Registering openModal.');

            if (winresReservationContextService.isReturnFromBank()) {
                openModal();
            }

            $scope.$on('winresOpenPopup', function (event, popup) {
                openModal();
            });
        },
        require: {
            context: '?^^winresReservationContext'
        },
        template: ''
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationPopup/winresReservationPopup.js
// module id = 272
// module chunks = 2